import { GET_LABOR_SHED, SET_LOADING } from "./laborshedTypes";

const initialState = {
	laborShed: "",
	loading: false,
};

const laborShedReducer = (state = initialState, action) => {
	switch (action.type) {
		case GET_LABOR_SHED:
			return {
				...state,
				laborShed: action.payload,
				loading: false,
			};
		case SET_LOADING:
			return {
				...state,
				loading: true,
			};
		default:
			return state;
	}
};

export default laborShedReducer;
